import { getSessionLanguageCode } from "../utils/CommonUtils.js"

export const AppConstant = {
    DEFAULT_MS_HOME_ACCOUNT_ID: "402c478d-0ddc-4f0e-b2da-c3a0d5a9831f",
    DEFAULT_CLIENT_ID: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
    AppVersion: "13.2.1", //"3.0.12",
    DeviceID: "51507c0e-f101-4abf-85b9-5ddfa2c9ebb7",
    OsVersion: "13",
    ManufactureModel: "Android SDK built for x86",
    App: "1",
    ClaimFromFlag: 0,
    /* AvailabilityCode values for which the map/calendar is hidden and the
    NoSpaceError image + AvailabilityMessage is shown instead:
    497	Vehicle missing! Please add one before you can book.
    498	Fully booked! Try a different date or check back later.
    499	You're early! Booking for this date hasn't started.
    601	You're all set—already booked in [zone-name]. */
    AVAILABILITY_BLOCKED_CODES: new Set([497, 498, 499, 601]),
    Longitude : "",
    Latitude :"",
    RegisterUserUniqueId: "",
    TERMS_LINKS: {
        en: "https://ronspotflexwork.com/terms/",
        fr: "https://ronspotflexwork.com/fr/conditions/",
        es: "https://ronspotflexwork.com/es/condiciones/",
        de: "https://ronspotflexwork.com/de/bedingungen/",
        nl: "https://ronspotflexwork.com/nl/voorwaarden/",
        it: "https://ronspotflexwork.com/it/termini/",
        cs: "https://ronspotflexwork.com/podminky/",
        pl: "https://ronspotflexwork.com/regulamin/",
        ga: "https://ronspotflexwork.com/tearmai/"

    },
    HELP_CENTRE: "https://ronspotflexwork.com/help-centre/",
    //RequestFrom: "react",
    RequestFrom: process.env.REACT_APP_REQUEST_FROM || "",
    // Fixed origin marker used where the API expects the literal "react"
    // (e.g. removeAccount's RequestFrom), independent of the env-based RequestFrom.
    React_hardcode: "react",
    get Language() {
        return getSessionLanguageCode();
    }
}

